// @greenlight-spec: 19-design-system.md

/**
 * Brings newly revealed content into view inside its scroll region. Honors
 * `prefers-reduced-motion` by jumping instead of animating; `scrollIntoView`
 * takes no easing parameter, so an animated scroll uses the platform's smooth
 * behavior (same call shape as the settings nav).
 */
export function revealElement(el: HTMLElement | null): void {
  if (!el || typeof el.scrollIntoView !== 'function') return;
  const prefersReduced =
    typeof window.matchMedia === 'function'
      ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
      : false;
  el.scrollIntoView({
    block: 'nearest',
    inline: 'nearest',
    behavior: prefersReduced ? 'instant' : 'smooth',
  });
}
